var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m202.776 198.79 9.24-20.023",
    stroke: "silver",
    strokeLinecap: "round",
    strokeWidth: 10.63,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "silver",
    strokeWidth: 10.63
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000"
    },
    transform: "translate(-.475 -78.523)",
    fill: "#f8f8f8",
    d: "M227.28 195.25c0 25.384-20.578 45.962-45.962 45.962s-45.962-20.578-45.962-45.962 20.578-45.962 45.962-45.962 45.962 20.578 45.962 45.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000"
    },
    fill: "#f8f8f8",
    d: "M180.82 232.13c-40.447 0-73.219 27.341-73.219 61.094 0 2.218.161 4.406.438 6.563h145.59c.276-2.157.437-4.345.437-6.563 0-33.752-32.803-61.094-73.25-61.094z",
    transform: "translate(.03 -68.421)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "m136.4 230.369 12.122-26.264M224.28 231.379l-12.12-26.27"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m362.016 198.79 9.24-20.023",
    stroke: "silver",
    strokeLinecap: "round",
    strokeWidth: 10.63,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "silver",
    strokeWidth: 10.63
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000"
    },
    transform: "translate(158.765 -78.523)",
    fill: "#f8f8f8",
    d: "M227.28 195.25c0 25.384-20.578 45.962-45.962 45.962s-45.962-20.578-45.962-45.962 20.578-45.962 45.962-45.962 45.962 20.578 45.962 45.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000"
    },
    fill: "#f8f8f8",
    d: "M180.82 232.13c-40.447 0-73.219 27.341-73.219 61.094 0 2.218.161 4.406.438 6.563h145.59c.276-2.157.437-4.345.437-6.563 0-33.752-32.803-61.094-73.25-61.094z",
    transform: "translate(159.27 -68.421)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "m295.64 230.369 12.122-26.264M383.52 231.379l-12.12-26.27"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m122.176 314.757 9.24-20.022",
    stroke: "silver",
    strokeLinecap: "round",
    strokeWidth: 10.63,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "silver",
    strokeWidth: 10.63
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000"
    },
    transform: "translate(-81.075 37.445)",
    fill: "#f8f8f8",
    d: "M227.28 195.25c0 25.384-20.578 45.962-45.962 45.962s-45.962-20.578-45.962-45.962 20.578-45.962 45.962-45.962 45.962 20.578 45.962 45.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000"
    },
    fill: "#f8f8f8",
    d: "M180.82 232.13c-40.447 0-73.219 27.341-73.219 61.094 0 2.218.161 4.406.438 6.563h145.59c.276-2.157.437-4.345.437-6.563 0-33.752-32.803-61.094-73.25-61.094z",
    transform: "translate(-80.57 47.547)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "m55.8 346.337 12.122-26.264M143.68 347.347l-12.12-26.27"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m435.736 314.757 9.24-20.022",
    stroke: "silver",
    strokeLinecap: "round",
    strokeWidth: 10.63,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "silver",
    strokeWidth: 10.63
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000"
    },
    transform: "translate(232.485 37.445)",
    fill: "#f8f8f8",
    d: "M227.28 195.25c0 25.384-20.578 45.962-45.962 45.962s-45.962-20.578-45.962-45.962 20.578-45.962 45.962-45.962 45.962 20.578 45.962 45.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000"
    },
    fill: "#f8f8f8",
    d: "M180.82 232.13c-40.447 0-73.219 27.341-73.219 61.094 0 2.218.161 4.406.438 6.563h145.59c.276-2.157.437-4.345.437-6.563 0-33.752-32.803-61.094-73.25-61.094z",
    transform: "translate(232.99 47.547)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "m369.36 346.337 12.122-26.264M457.24 347.347l-12.12-26.27"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#e4e4e4"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    style: {
      color: "#000"
    },
    d: "M443.16 414.45c0 36.096-29.262 65.358-65.358 65.358s-65.358-29.262-65.358-65.358 29.262-65.358 65.358-65.358 65.358 29.262 65.358 65.358z",
    transform: "matrix(1.5 0 0 1.5 -312.213 -348.827)",
    strokeLinecap: "round",
    strokeWidth: 10.63,
    fill: "#f8f8f8"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 7.9725,
    fill: "none",
    d: "M256.752 178.153v188.64"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 7.9725,
    strokeLinecap: "round",
    fill: "none",
    d: "M256.752 177.403s-51.518-2.497-51.518 98.49c0 90.156 51.518 92.429 51.518 92.429s51.904 2.195 52.275-93.944c.37-96.139-52.275-96.975-52.275-96.975z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 7.9725,
    strokeLinecap: "round",
    fill: "none",
    d: "M158.262 277.603v.218s.845 30.465 96.984 30.25c96.14-.214 93.937-30.25 93.937-30.25s-.032-.118-.047-.218"
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    style: {
      color: "#000"
    },
    d: "M443.16 414.45c0 36.096-29.262 65.358-65.358 65.358s-65.358-29.262-65.358-65.358 29.262-65.358 65.358-65.358 65.358 29.262 65.358 65.358z",
    transform: "matrix(1.5 0 0 1.5 -312.01 -348.647)",
    strokeLinecap: "round",
    strokeWidth: 10.63,
    fill: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m202.776 424.358 9.24-20.022",
    stroke: "silver",
    strokeLinecap: "round",
    strokeWidth: 10.63,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "silver",
    strokeWidth: 10.63
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000"
    },
    transform: "translate(-.475 147.046)",
    fill: "#f8f8f8",
    d: "M227.28 195.25c0 25.384-20.578 45.962-45.962 45.962s-45.962-20.578-45.962-45.962 20.578-45.962 45.962-45.962 45.962 20.578 45.962 45.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000"
    },
    fill: "#f8f8f8",
    d: "M180.82 232.13c-40.447 0-73.219 27.341-73.219 61.094 0 2.218.161 4.406.438 6.563h145.59c.276-2.157.437-4.345.437-6.563 0-33.752-32.803-61.094-73.25-61.094z",
    transform: "translate(.03 157.148)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "m136.4 455.938 12.122-26.264M224.28 456.948l-12.12-26.27"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m362.016 424.358 9.24-20.022",
    stroke: "silver",
    strokeLinecap: "round",
    strokeWidth: 10.63,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "silver",
    strokeWidth: 10.63
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000"
    },
    transform: "translate(158.765 147.046)",
    fill: "#f8f8f8",
    d: "M227.28 195.25c0 25.384-20.578 45.962-45.962 45.962s-45.962-20.578-45.962-45.962 20.578-45.962 45.962-45.962 45.962 20.578 45.962 45.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000"
    },
    fill: "#f8f8f8",
    d: "M180.82 232.13c-40.447 0-73.219 27.341-73.219 61.094 0 2.218.161 4.406.438 6.563h145.59c.276-2.157.437-4.345.437-6.563 0-33.752-32.803-61.094-73.25-61.094z",
    transform: "translate(159.27 157.148)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "m295.64 455.938 12.122-26.264M383.52 456.948l-12.12-26.27"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.1b8736976498948dca1f173651cac02b.svg";
export { ForwardRef as ReactComponent };